import i18n from '@/lang/index'

export default [
  {
    element: '.driver-item-chart',
    popover: {
      operate: {
        openMenu: 'dataBoard'
      },
      title: i18n.t('public.history_data'),
      description: i18n.t('public.carrier_history_step_desc_1')
    }
  },
  {
    permission: ['viewMonitorPointRealTime'],
    element: '.driver-item-monitoringPoint',
    popover: {
      title: i18n.t('public.history_data'),
      description: i18n.t('public.history_desc_2')
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    permission: ['viewMonitorPointRealTime'],
    element: '.driver-item-sample-chart',
    popover: {
      title: i18n.t('public.history_data'),
      description: i18n.t('public.carrier_history_step_desc_1'),
      operate: {
        openMenu: 'business'
      }
    }
  },
  {
    permission: ['viewIncubator'],
    element: '.driver-item-incubator',
    popover: {
      title: i18n.t('public.history_data'),
      description: i18n.t('public.carrier_history_step_desc_2'),
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    permission: ['viewIncubator'],
    element: '.driver-item-chart',
    popover: {
      title: i18n.t('public.history_data'),
      description: i18n.t('public.carrier_history_step_desc_1')
    }
  }
]
